import { getTimeline } from '../infrastructure/api-egg'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useToken } from './useToken'

export const useTimeline = (courseId?: string) => {
    const queryClient = useQueryClient()
    const { _classId } = useToken()
    const id = courseId ?? _classId
    const queryKey = ['Team', 'Timeline', id]

    const { data, ...rest } = useQuery({
        queryKey,
        queryFn: () => getTimeline(id),
        enabled: !!id,
    })

    const invalidateTimeLine = () => queryClient.invalidateQueries({ queryKey })

    return {
        ...data,
        ...rest,
        invalidateTimeLine,
    }
}
